export default __webpack_public_path__ + "static/media/menu-text-panel.742630cc.png";